var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpgrader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.62 21.3501C14.18 20.6001 15.32 22.9801 13.76 23.7301L3.89 28.3001C1.97 29.1601 0 28.2701 0 25.9601V21.4201C0 19.9101 0.17 19.2901 1.15 18.1201L15.05 3.72009C15.1725 3.59181 15.3195 3.48952 15.4824 3.41933C15.6452 3.34913 15.8205 3.31248 15.9979 3.31154C16.1752 3.31061 16.3509 3.34542 16.5145 3.41389C16.6781 3.48237 16.8262 3.58311 16.95 3.71009L30.85 18.1201C31.83 19.2901 32 19.9101 32 21.4201V25.9601C32 28.0701 29.94 29.3901 28.13 28.3001L18.55 23.7701C16.98 23.0201 18.11 20.6301 19.68 21.3701L28.78 25.6801C28.8408 25.7086 28.9078 25.7214 28.9749 25.7172C29.0419 25.7131 29.1068 25.6921 29.1636 25.6562C29.2204 25.6203 29.2672 25.5707 29.2998 25.512C29.3324 25.4533 29.3497 25.3873 29.35 25.3201V21.4201C29.35 20.6901 29.41 20.5201 28.96 19.9701L16 6.54009L3.04 19.9701C2.59 20.5101 2.64 20.6901 2.64 21.4201V25.3201C2.64 25.4601 2.71 25.5801 2.84 25.6601C2.8967 25.6947 2.96113 25.7147 3.02747 25.7182C3.09381 25.7217 3.15998 25.7086 3.22 25.6801L12.62 21.3501Z",
    fill: "url(#paint0_linear_69_12333)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_12333",
    x1: 16,
    y1: 3.31152,
    x2: 7.16585e-7,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD48F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E30F3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrader);
export default __webpack_public_path__ + "static/media/upgrader.a55470550a588cca47c8bc37296a6167.svg";
export { ForwardRef as ReactComponent };